import React from 'react';

const FileIconCareers = function FileIconCareers(): JSX.Element {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.33331 7C8.33331 5.89543 9.22874 5 10.3333 5H19.75C19.8881 5 20 5.11193 20 5.25V14.6667C20 15.7712 20.8954 16.6667 22 16.6667H31.4166C31.5547 16.6667 31.6666 16.7786 31.6666 16.9167V33C31.6666 34.1046 30.7712 35 29.6666 35H10.3333C9.22874 35 8.33331 34.1046 8.33331 33V7Z" fill="#2065EC" fillOpacity="0.5" />
      <path d="M21.6667 14V5.60355C21.6667 5.38083 21.936 5.26929 22.0935 5.42678L31.2399 14.5732C31.3974 14.7307 31.2859 15 31.0631 15H22.6667C22.1144 15 21.6667 14.5523 21.6667 14Z" fill="#222222" />
      <path d="M14.1667 22.5L24.1667 22.5" stroke="#222222" strokeLinecap="round" />
      <path d="M14.1667 27.5L22.5 27.5" stroke="#222222" strokeLinecap="round" />
    </svg>
  );
};

export default FileIconCareers;
